import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WhitelevelComponent } from './whitelevel/whitelevel.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { DasaInterceptor } from './services/interceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { ChatBoxComponent } from './chat-box/chat-box.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [
        AppComponent,
        WhitelevelComponent,
        ChatBoxComponent
    ],
    bootstrap: [AppComponent], imports: [
        ToastrModule.forRoot(),
        CommonModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }), NgbModule], providers: [{ provide: LOCALE_ID, useValue: 'en' }, { provide: HTTP_INTERCEPTORS, useClass: DasaInterceptor, multi: true }, provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),] })
export class AppModule { }
//  OwlNativeDateTimeModule, was inside import
